(() => {
  const url = new URL(window.location.href);
  const loader = document.getElementById('mm-gb-route-loader');
  if (!loader?.dataset.themeId || loader.dataset.themeId !== loader.dataset.candidateId) return;
  const role = loader.dataset.themeRole;
  if (role !== 'main') return;
  if (url.hostname !== 'moomenn.com' || url.protocol !== 'https:') return;
  if (/^\/en-eu(?:\/|$)/i.test(url.pathname)) return; // Preserve an explicit market URL.
  if (['preview_theme_id', 'pb', '_ab'].some((key) => url.searchParams.has(key))) return;
  if (/bot|crawl|spider|slurp|facebookexternalhit|twitterbot/i.test(navigator.userAgent)) return;
  if (/^\/(cart|checkout|checkouts|account|customer_authentication|password)(\/|$)/i.test(url.pathname)) return;
  if (/^\/apps\//i.test(url.pathname)) return;

  const preferenceKey = 'moomenn-stay-us-this-tab';
  const routedThisTabKey = 'moomenn-uk-routed-this-tab';
  const fromSameStore = (() => {
    try { return !!document.referrer && new URL(document.referrer).origin === url.origin; }
    catch (_) { return false; }
  })();
  try {
    // Retire the former permanent choice; an explicit choice now lasts one tab.
    localStorage.removeItem('moomenn-stay-us');
    if (url.searchParams.get('mm_auto') === '1') sessionStorage.removeItem(preferenceKey);
    else if (url.searchParams.get('mm_stay_us') === '1') sessionStorage.setItem(preferenceKey, '1');
    else if (performance.getEntriesByType('navigation')[0]?.type === 'navigate' && !fromSameStore) {
      // A fresh direct/external arrival uses location again; internal shopping retains the choice.
      sessionStorage.removeItem(preferenceKey);
    }
    if (sessionStorage.getItem(preferenceKey) === '1') return;
    // Suppress only a history return after our own redirect, not later direct visits.
    if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward' &&
        sessionStorage.getItem(routedThisTabKey) === '1') return;
  } catch (_) { return; }

  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then((response) => response.ok ? response.json() : null)
    .then((data) => {
      if (data?.detected_values?.country?.handle !== 'GB') return;
      try {
        if (sessionStorage.getItem(preferenceKey) === '1') return;
        sessionStorage.setItem(routedThisTabKey, '1');
      } catch (_) { return; }
      window.location.assign('https://moomenn.co.uk/');
    })
    .catch(() => {});
})();
